/** @format */

import React from 'react';
import withQuoteHandler from './with_quote_handler';
import {InputWithErrorHandler, SelectWithErrorHandler, handleChange} from 'frontier-form';
import NumberFormat from 'react-number-format';
import {
    FORM_FACTOR_HAND_APPLIED,
    FORM_FACTOR_ROLLS,
    LAMINATES,
    SHAPE_CIRCLE,
    SHAPE_SQUARE,
    SHAPE_TYPES,
    SHAPE_CUSTOM,
    SIZE_TYPE_STANDARD,
    SUBSTRATES,
    DISCONTINUED_NEW_ORDER_SUBSTRATES
} from 'frontier-constants';
import {ConditionalButton} from 'frontier-utilities';

const sizeErrorStyle = {
    position: 'absolute',
    top: '13px',
    left: '-5px',
    fontSize: '11px',
    minWidth: '130px'
};

export default withQuoteHandler(
    handleChange(function Quote({order, ...props}) {
        const isWidthSnapped = (order.width * 1000) % 125 === 0;
        const isLengthSnapped = (order.length * 1000) % 125 === 0;

        return (
            <div style={{marginBottom: '15px'}}>
                <div className="d-flex">
                    <div
                        style={{
                            fontSize: '24px',
                            marginRight: '20px',
                            paddingTop: '30px'
                        }}>
                        {props.index + 1}.
                    </div>
                    <div className="d-flex flex-wrap align-items-center" style={{maxWidth: '75%'}}>
                        <div className="form-group mr-2">
                            <label>Order Name</label>
                            <InputWithErrorHandler
                                style={{width: '175px'}}
                                value={order.customer_label}
                                className="form-control"
                                onChange={props.onInputChange.bind(this, `order.customer_label`)}
                            />
                        </div>
                        <div className="form-group mr-2">
                            <label>Shape</label>
                            <SelectWithErrorHandler
                                emptyText="-- Choose a Shape --"
                                className="form-control"
                                options={SHAPE_TYPES.filter(({id}) => id !== SHAPE_CUSTOM).map(
                                    ({label, id, is_square_corners}) => {
                                        const shapeId = `${id}_${is_square_corners}`;
                                        return {
                                            label,
                                            id: shapeId
                                        };
                                    }
                                )}
                                value={order.shape_id + '_' + order.is_square_corners}
                                onChange={({target: {value}}) => {
                                    const [shapeId, isSquareCorners] = value.split('_');
                                    const updateTarget = {
                                        order: {
                                            size_id: {$set: -1},
                                            size_type_id: {$set: SIZE_TYPE_STANDARD},
                                            is_square_corners: {$set: isSquareCorners},
                                            shape_id: {$set: shapeId}
                                        }
                                    };

                                    if (order.length > 0) {
                                        if (shapeId === SHAPE_CIRCLE || shapeId === SHAPE_SQUARE) {
                                            // Make sure the dimensions match
                                            updateTarget.order.length = {$set: order.width};
                                        } else if (order.width === order.length) {
                                            // We are changing to a non square shape
                                            updateTarget.order.length = {
                                                $set: parseFloat(order.length) + 0.125
                                            };
                                        }
                                    }
                                    props.onChangeBypass(updateTarget);
                                }}
                            />
                        </div>
                        <div className="form-group mr-2 position-relative">
                            <label>Width</label>
                            {!isWidthSnapped && (
                                <span
                                    className="text-danger ml-2 align-right"
                                    style={sizeErrorStyle}>
                                    Round to 1/8th inch (
                                    {(Math.round(order.width * 8) / 8).toFixed(3)})
                                </span>
                            )}
                            <NumberFormat
                                style={{width: '110px'}}
                                thousandSeparator={false}
                                decimalScale={3}
                                fixedDecimalScale={true}
                                value={order.width === 0 ? '' : order.width}
                                className="form-control"
                                onValueChange={({floatValue}) => {
                                    props.onChangeBypass({
                                        order: {
                                            size_id: {$set: -1},
                                            width: {$set: floatValue}
                                        }
                                    });
                                }}
                            />
                        </div>
                        <div className="form-group mr-2 position-relative">
                            <label>Length</label>
                            {!isLengthSnapped && (
                                <span
                                    className="text-danger ml-2 align-right"
                                    style={sizeErrorStyle}>
                                    Round to 1/8th inch (
                                    {(Math.round(order.length * 8) / 8).toFixed(3)})
                                </span>
                            )}
                            <NumberFormat
                                style={{width: '110px'}}
                                thousandSeparator={false}
                                decimalScale={3}
                                fixedDecimalScale={true}
                                value={order.length === 0 ? '' : order.length}
                                className="form-control"
                                onValueChange={({floatValue}) => {
                                    props.onChangeBypass({
                                        order: {
                                            size_id: {$set: -1},
                                            length: {$set: floatValue}
                                        }
                                    });
                                }}
                            />
                        </div>
                        <div className="form-group mr-2">
                            <label>Total Qty</label>
                            <NumberFormat
                                style={{width: '100px'}}
                                thousandSeparator={true}
                                decimalScale={0}
                                fixedDecimalScale={true}
                                value={order.total_qty === 0 ? '' : order.total_qty}
                                className="form-control"
                                onChange={props.onNumberInputChange.bind(this, `order.total_qty`)}
                            />
                        </div>
                        <div className="form-group mr-2">
                            <label>Design Qty</label>
                            <NumberFormat
                                style={{width: '100px'}}
                                thousandSeparator={true}
                                decimalScale={0}
                                fixedDecimalScale={true}
                                value={order.design_qty === 0 ? '' : order.design_qty}
                                className="form-control"
                                onChange={props.onNumberInputChange.bind(this, `order.design_qty`)}
                            />
                        </div>
                        <div className="form-group mr-2">
                            <label>Material</label>
                            <SelectWithErrorHandler
                                emptyText="-- Choose a Material --"
                                options={SUBSTRATES.filter(({id}) => {
                                    return (
                                        DISCONTINUED_NEW_ORDER_SUBSTRATES.findIndex(
                                            ({id: discontinuedId}) => discontinuedId === id
                                        ) === -1
                                    );
                                })}
                                value={order.substrate_id}
                                className="form-control"
                                onChange={props.onInputChange.bind(this, `order.substrate_id`)}
                            />
                        </div>
                        <div className="form-group mr-2">
                            <label>Laminate</label>
                            <SelectWithErrorHandler
                                emptyText="-- Choose a Laminate --"
                                options={LAMINATES}
                                value={order.laminate_id}
                                className="form-control"
                                onChange={props.onInputChange.bind(this, `order.laminate_id`)}
                            />
                        </div>

                        <div className="form-group mr-2">
                            <label>Label Application</label>
                            <SelectWithErrorHandler
                                emptyText="-- Choose Label Application --"
                                options={[
                                    {
                                        id: FORM_FACTOR_HAND_APPLIED + '_' + 1,
                                        label: 'Hand Applied'
                                    },
                                    {
                                        id: FORM_FACTOR_ROLLS + '_' + 1,
                                        label: 'Machine RD 1'
                                    },
                                    {
                                        id: FORM_FACTOR_ROLLS + '_' + 2,
                                        label: 'Machine RD 2'
                                    },
                                    {
                                        id: FORM_FACTOR_ROLLS + '_' + 3,
                                        label: 'Machine RD 3'
                                    },
                                    {
                                        id: FORM_FACTOR_ROLLS + '_' + 4,
                                        label: 'Machine RD 4'
                                    }
                                ]}
                                value={order.form_factor_id + '_' + order.roll_direction_id}
                                className="form-control"
                                onChange={({target: {value}}) => {
                                    const [formFactorId, rollDirectionId] = value.split('_');
                                    props.onChangeBypass({
                                        order: {
                                            form_factor_id: {$set: parseInt(formFactorId)},
                                            roll_direction_id: {$set: parseInt(rollDirectionId)}
                                        }
                                    });
                                }}
                            />
                        </div>
                    </div>
                    <div
                        className="d-flex flex-column align-items-center justify-content-around"
                        style={{
                            border: 'solid 1px #ccc',
                            marginLeft: '10px',
                            padding: '0 10px',
                            minWidth: '181px'
                        }}>
                        <div>
                            <div>
                                <NumberFormat
                                    style={{fontSize: '32px'}}
                                    className="ml-2 mr-2"
                                    value={props.quotedTotal}
                                    displayType="text"
                                    thousandSeparator={true}
                                    decimalScale={2}
                                    fixedDecimalScale={true}
                                    prefix="$"
                                />
                            </div>
                            <div>
                                <NumberFormat
                                    style={{fontSize: '14px'}}
                                    className="ml-2 mr-2"
                                    value={(props.quotedTotal / order.total_qty).toFixed(3) || 0}
                                    displayType="text"
                                    thousandSeparator={true}
                                    decimalScale={2}
                                    fixedDecimalScale={true}
                                    prefix="$"
                                />
                                per label{' '}
                                {props.isUpdating && <i className="fa fa-spin fa-spinner ml-2" />}
                            </div>
                        </div>
                        <div>
                            {props.quotedTotal > 0 &&
                                order.total_qty > 0 &&
                                order.design_qty > 0 &&
                                !props.isUpdating && (
                                    <ConditionalButton enabled={props.isSaving}>
                                        <button
                                            disabled="disabled"
                                            className="btn btn-outline-secondary mr-4">
                                            <i className="fa fa-spin fa-spinner" />
                                        </button>
                                        <button
                                            onClick={props.onSave}
                                            className="btn btn-outline-secondary mr-4">
                                            <i className="fa fa-save" />
                                        </button>
                                    </ConditionalButton>
                                )}
                            <button className="btn btn-outline-danger " onClick={props.onDelete}>
                                <i className="fa fa-close" />
                            </button>
                        </div>
                    </div>
                </div>
                {props.isLastQuote && (
                    <>
                        <hr />
                        <button className="btn btn-outline-secondary" onClick={props.onAddQuote}>
                            Add Quote
                        </button>
                    </>
                )}
            </div>
        );
    })
);
